import * as types from "./types";

export const getTrainingWorkingSlotsRequest = (payload) => ({
  type: types.GET_TRAINING_WORKING_SLOTS_REQUEST,
  payload,
});

export const getTrainingWorkingSlotsResponse = (payload) => ({
  type: types.GET_TRAINING_WORKING_SLOTS_RESPONSE,
  payload,
});

export const addTrainingWorkingSlot = (payload) => ({
  type: types.ADD_TRAINING_WORKING_SLOT,
  payload,
});

export const editTrainingWorkingSlotRequest = (payload) => ({
  type: types.EDIT_TRAINING_WORKING_SLOT_REQUEST,
  payload,
});

export const deleteTrainingWorkingSlotRequest = (payload) => ({
  type: types.DELETE_TRAINING_WORKING_SLOT_REQUEST,
  payload,
});
